export default "__VITE_ASSET__6ed67676__"